import QRCode from 'qrcode';

/**
 * Convierte un payload (URL HTTPS) en un dataURL PNG del QR.
 * Tamaño 512x512 → escalable sin pérdida en pantalla TV.
 */
export async function renderQrDataUrl(payload: string): Promise<string> {
  return QRCode.toDataURL(payload, {
    errorCorrectionLevel: 'M',
    width: 512,
    margin: 2,
    color: { dark: '#0b0b0f', light: '#f4ecd8' },
  });
}
